export enum RecipeMediaTypeEnum {
  PHOTO = 'PHOTO',
  VIDEO = 'VIDEO'
}
